import { FC, useEffect, useState } from 'react'
import { Button, ButtonGroup, Form } from 'react-bootstrap'
import { ImageFieldProps } from '../Forms.d'
import ImagePlaceholderLightSrc from './../../../../assets/img/image-placeholder.png'
import ImagePlaceholderDarkSrc from './../../../../assets/img/image-placeholder-dark.png'
import { useAppSelector } from '../../../../store/hooks'
import useBreakpoint from '../../../../hooks/useBreakpoints'

const ImageField: FC<ImageFieldProps> = ({
    id,
    label = '',
    showLabel = true,
    name,
    formikProps,
    groupClassName = '',
    allowRemoveImage,
    setAllowRemoveImage,
    previewSrc,
    setPreviewSrc,
    imageId,
    alt = '',
    updateRecord,
    groupStyle,
    imgStyle,
    imgBgClass = '',
}) => {
    const theme = useAppSelector((state) => state.theme.theme)
    const [imageIsReady, setImageIsReady] = useState(false)
    const [imageSrc, setImageSrc] = useState(
        previewSrc || (theme === 'dark' ? ImagePlaceholderDarkSrc : ImagePlaceholderLightSrc)
    )

    const breakpoint = useBreakpoint()

    useEffect(() => {
        const img = new Image()
        img.onload = () => {
            setImageIsReady(true)
        }
        if (previewSrc) img.src = previewSrc

        setImageSrc(
            previewSrc !== ''
                ? previewSrc
                : theme === 'dark'
                ? ImagePlaceholderDarkSrc
                : ImagePlaceholderLightSrc
        )
    }, [previewSrc, theme])

    return (
        <Form.Group
            className={(groupClassName || '') + ' w-100 sfy-field mb-3'}
            controlId={id}
            style={groupStyle || {}}
        >
            {showLabel && <Form.Label>{label}</Form.Label>}
            <Form.Control
                as="input"
                type="file"
                className="d-none"
                name={name}
                onChange={(e: any) => {
                    setAllowRemoveImage(true)
                    setPreviewSrc(URL.createObjectURL(e.target.files[0]))
                    formikProps.setFieldValue(name, e.target.files[0])
                }}
            />

            <div
                className={`w-100 d-flex align-items-center justify-content-center mb-2 ${imgBgClass}`}
                style={{ display: 'block' }}
            >
                <img
                    className={
                        'd-block' +
                        (id !== null && !imageIsReady ? ' with-preloader' : '')
                    }
                    src={imageSrc || undefined}
                    alt={alt}
                    style={{
                        maxHeight: '20rem',
                        maxWidth: '100%',
                        ...imgStyle,
                    }}
                />
            </div>
            <ButtonGroup
                className="w-100"
                vertical={breakpoint !== 'lg' && breakpoint !== 'xl'}
            >
                <Button
                    size="sm"
                    variant={`outline-${
                        theme === 'dark' ? 'dark' : 'secondary'
                    }`}
                    onClick={() => {
                        document.getElementById(id).click()
                    }}
                >
                    {imageId ? 'Change' : 'Upload'}
                </Button>
                {imageId && (
                    <Button
                        size="sm"
                        variant={`outline-${
                            theme === 'dark' ? 'dark' : 'secondary'
                        }`}
                        onClick={() => {
                            setAllowRemoveImage(true)
                            setPreviewSrc(
                                imageId
                                    ? `${process.env.REACT_APP_API_ROOT_URL}/media/download/${imageId}`
                                    : ''
                            )
                        }}
                    >
                        Reset
                    </Button>
                )}
                <Button
                    size="sm"
                    variant="outline-danger"
                    disabled={!allowRemoveImage}
                    onClick={() => {
                        setAllowRemoveImage(false)
                        setPreviewSrc('')
                        updateRecord((prevState) => {
                            return {
                                ...prevState,
                                [name]: null,
                            }
                        })
                    }}
                >
                    Remove
                </Button>
            </ButtonGroup>
            <span className="bottom-border"></span>
        </Form.Group>
    )
}

export default ImageField
